import React, { useContext } from 'react';

import LayoutContext from './LayoutContext';

export default function useLayout() {
  const layout = useContext(LayoutContext);
  return layout;
}
